<template>
  <v-container grid-list-md class="antecip-page">
    <div class="antecip-card">
      <antecipations-header />
      <div class="antecip-features">
        <automatic-antecipation />
        <manual-antecipation />
      </div>
    </div>
    <automatic-anticipation-terms />
  </v-container>
</template>
<script>
export default {
  name: "Anticipations",
  created() {
    this.$store.dispatch("user/loadAccount");
  },
  components: {
    ManualAntecipation: () =>
      import("@/components/antecipation/ManualAntecipation.vue"),
    AutomaticAntecipation: () =>
      import("@/components/antecipation/AutomaticAntecipation.vue"),
    AntecipationsHeader: () =>
      import("@/components/antecipation/AnticipationsHeader.vue"),
    AutomaticAnticipationTerms: () =>
      import("@/components/antecipation/AutomaticAnticipationTerms.vue"),
  },
};
</script>

<style scoped>
.antecip-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 16px 12px 40px;
}

.antecip-card {
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 12px 34px rgba(17, 24, 39, 0.08);
  overflow: hidden;
  padding: 8px 8px 20px;
}

.antecip-features {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
}

@media screen and (max-width: 600px) {
  .antecip-card {
    border-radius: 18px;
  }
  .antecip-features {
    padding: 0 8px;
  }
}
</style>
